/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Meta_DescriptionInputs */

const es_faq_meta_description = /** @type {(inputs: Faq_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuestas sobre alquiler lista 7ª, experiencias, comisión 15%, seguros, ITB, pagos y trámites. FAQ para armadores en Zarpar.`)
};

const gl_faq_meta_description = /** @type {(inputs: Faq_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respostas sobre alugueiro lista 7ª, experiencias, comisión 15%, seguros, ITB, pagos e trámites. FAQ para armadores en Zarpar.`)
};

const en_faq_meta_description = /** @type {(inputs: Faq_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers on List 7 rental, experiences, 15% commission, insurance, ITB, payments and paperwork. FAQ for boat owners on Zarpar.`)
};

/**
* | output |
* | --- |
* | "Answers on List 7 rental, experiences, 15% commission, insurance, ITB, payments and paperwork. FAQ for boat owners on Zarpar." |
*
* @param {Faq_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_meta_description = /** @type {((inputs?: Faq_Meta_DescriptionInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Meta_DescriptionInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_faq_meta_description(inputs)
	if (locale === "en") return en_faq_meta_description(inputs)
	return es_faq_meta_description(inputs)
});